import { create } from 'zustand';
import { dashboardApi } from '../api/dashboard.api.js';

const SEEN_KEY = 'crm-seen-notifications';

function readSeen() {
  try {
    return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || '[]'));
  } catch {
    return new Set();
  }
}

export const useNotificationStore = create((set, get) => ({
  attention: [],
  events: [],
  unreadConversations: 0,
  seen: readSeen(),
  loaded: false,

  fetch: async () => {
    try {
      const { data } = await dashboardApi.notifications();
      set({
        attention: data.attention || [],
        events: data.events || [],
        unreadConversations: data.unreadConversations || 0,
        loaded: true,
      });
    } catch {
      set({ loaded: true });
    }
  },

  markAllSeen: () => {
    const ids = [...get().attention, ...get().events].map((item) => item.id);
    const seen = new Set([...get().seen, ...ids]);
    try {
      localStorage.setItem(SEEN_KEY, JSON.stringify([...seen].slice(-300)));
    } catch {}
    set({ seen });
  },

  unseenCount: () => {
    const { attention, events, seen } = get();
    return [...attention, ...events].filter((item) => !seen.has(item.id)).length;
  },
}));
